module.exports = __webpack_public_path__ + "static/Elephant-43cd3b9e544f2df887dae1c0386b921f.jpg";